import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Box, Typography, Button, Grid } from "@material-ui/core";
import { MutantApiService } from "../../services/MutantApiService";
import { StyledCardBody } from "../../pages/admin/components/AdminCard/style";
import { InputField } from "../../pages/admin/components/InputField";
import { Card } from "react-bootstrap";
import moment from 'moment';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Swal from "sweetalert2";
import draftToHtml from 'draftjs-to-html';
import { ContentState, convertToRaw, EditorState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';

export function MaintenanceSettingsPage() {
	const history = useHistory();
	const api = new MutantApiService();

	const [state, setState] = useState({
		message: '',
		startDateTime: moment().format('YYYY-MM-DDTHH:mm'),
		endDateTime: moment().format('YYYY-MM-DDTHH:mm'),
		editorState: EditorState.createEmpty(),
	});

	const onEditorStateChange = (editorState) => {
		setState({
			...state,
			editorState,
		});
	};

	const handleInputChange = (event) => {
		setState({
			...state,
			[event.target.name]: event.target.value,
		});
	};

	const fetchMaintenanceInfo = async () => {
		try {
			const response = await api.makeHttpRequest({
				url: `/maintenance`,
				method: "GET"
			});
			let message = response.message;
			try {
				message = atob(response.message);
			} catch (error) {
				console.error(error);
			}

			const startDateTime = response.startDateTime;
			const endDateTime = response.endDateTime;


			const blocksFromHTML = htmlToDraft(message || '');
			const contentState = ContentState.createFromBlockArray(
				blocksFromHTML.contentBlocks,
				blocksFromHTML.entityMap
			);

			setState({
				message: message || '',
				startDateTime: moment(startDateTime).format('YYYY-MM-DDTHH:mm'),
				endDateTime: moment(endDateTime).format('YYYY-MM-DDTHH:mm'),
				editorState: EditorState.createWithContent(contentState),
			});
		} catch (error) {
			console.error(error);
			Swal.fire('Erro', 'Falha ao buscar as informações de manutenção.', 'error');
		}
	};

	useEffect(() => {
		fetchMaintenanceInfo();
	}, []);

	const handleSave = async () => {
		if (moment(state.startDateTime).isAfter(moment(state.endDateTime))) {
			Swal.fire('Erro', 'A data de início deve ser anterior à data de término.', 'error');
			return;
		}

		const rawContentState = convertToRaw(state.editorState.getCurrentContent());
		const markup = draftToHtml(rawContentState);

		const data = {
			message: btoa(markup),
			startDateTime: new Date(state.startDateTime).toISOString(),
			endDateTime: new Date(state.endDateTime).toISOString(),
		};

		const headers = {
			'Access-Control-Allow-Origin': 'https://blackbolt-dev.cxmsolution.com.br',
			'Access-Control-Allow-Methods': 'GET, POST, PATCH',
			'Access-Control-Allow-Headers': 'Content-Type',
		};

		try {
			await api.makeHttpRequest({
				url: `/maintenance`,
				method: "PATCH",
				data,
				headers,
			});
			Swal.fire(
				{
					title: 'Sucesso',
					text: 'Informações de manutenção atualizadas.',
					icon: 'success',
					confirmButtonText: 'Ok',
				}).then(() => {
					history.push('/dashboard/settings');
				});
		} catch (error) {
			console.error(error);
			Swal.fire('Erro', 'Falha ao atualizar as informações de manutenção.', 'error');
		}

		try {
			await api.makeHttpRequest({
				url: `/maintenance`,
				method: "PATCH",
				data
			});
			Swal.fire(
				{
					title: 'Sucesso',
					text: 'Informações de manutenção atualizadas.',
					icon: 'success',
					confirmButtonText: 'Ok',
				}).then(() => {
					history.push('/dashboard/settings');
				});
		} catch (error) {
			console.error(error);
			Swal.fire('Erro', 'Falha ao atualizar as informações de manutenção.', 'error');
		}
	};

	return (
		<>
			<Box display="flex">
				<Typography style={{
					fontSize: "40px",
					color: "#000000",
					fontWeight: "500",
				}}>Informações sobre manutenção</Typography>
			</Box>
			<Card className="mt-4">
				<StyledCardBody>
					<Grid container spacing={3}>
						<Grid item xs={12} sm={12}>
							<Editor
								editorState={state.editorState}
								toolbarClassName="toolbarClassName"
								wrapperClassName="wrapperClassName"
								wrapperStyle={{ border: '1px solid black', borderRadius: '5px' }}
								editorClassName="editorClassName"
								editorStyle={{ minHeight: '400px' }}
								onEditorStateChange={onEditorStateChange}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<InputField
								name="startDateTime"
								label="Data prevista para início"
								type="datetime-local"
								value={state.startDateTime}
								onChange={handleInputChange}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<InputField
								name="endDateTime"
								label="Data prevista para fim"
								type="datetime-local"
								value={state.endDateTime}
								onChange={handleInputChange}
							/>
						</Grid>
						<Grid item xs={12} sm={12}
							style={{
								display: "flex",
								justifyContent: "flex-end",
								alignItems: "center",
							}}
						>
							<Button
								variant="contained"
								style={{
									backgroundColor: "#9036F7",
									color: "#ffffff",
									marginTop: "10px",
									marginRight: "10px",
									width: "120px",
									fontFamily: "Maison Neue Bold",
									fontWeight: "normal",
									fontSize: "14px",
									lineHeight: "150%",
									textTransform: "uppercase",
									borderRadius: "4px",
									height: "50px",
								}}

								onClick={handleSave}
							>
								Salvar
							</Button>
						</Grid>
					</Grid>
				</StyledCardBody>
			</Card>
		</>
	);
}

export default MaintenanceSettingsPage;